(function () {
  'use strict';

  var STORAGE_KEY = 'cap_quote_stage_status_v2';
  var TOKEN_KEY = 'cap_quote_stage_token_v1';
  var STATUS_TTL_MS = 30 * 60 * 1000;
  var TERMINAL_TIMEOUT_MS = 120 * 1000;
  var statusEl = null;
  var observer = null;
  var lastAction = '';
  var rendering = false;
  var state = null;
  var realtimeClient = null;
  var realtimeChannel = null;
  var terminalTimer = 0;
  var quoteLoaderEl = null;

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeUrl(value) {
    try {
      var raw = String(value || '').trim();
      if (!raw) return '';
      var parsed = new URL(raw, window.location.origin);
      return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }


  function safeMondayUrl(value) {
    var url = safeUrl(value);
    if (!url) return '';
    try {
      var parsed = new URL(url);
      var validHost = parsed.hostname === 'callahan-auto-parts.monday.com';
      var validPath = /^\/boards\/9726565776\/views\/252022714\/pulses\/\d+$/.test(parsed.pathname);
      return validHost && validPath ? parsed.href : '';
    } catch (error) {
      return '';
    }
  }

  function isToken(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(String(value || '').trim().toLowerCase());
  }


  function getQuoteLoader() {
    if (quoteLoaderEl && document.body.contains(quoteLoaderEl)) return quoteLoaderEl;
    if (!document.body) return null;
    quoteLoaderEl = document.createElement('div');
    quoteLoaderEl.id = 'cap-quote-loader';
    quoteLoaderEl.className = 'callahan-loader callahan-loader--overlay';
    quoteLoaderEl.hidden = true;
    quoteLoaderEl.setAttribute('role', 'status');
    quoteLoaderEl.setAttribute('aria-live', 'polite');
    quoteLoaderEl.setAttribute('aria-label', 'Creating quote');
    quoteLoaderEl.innerHTML =
      '<div class="callahan-loader__tile" aria-hidden="true">' +
        '<div class="callahan-loader__bars"><i></i><i></i><i></i></div>' +
        '<div class="callahan-loader__mark"><img alt="" decoding="async"></div>' +
      '</div>' +
      '<div class="callahan-loader__text">Creating your quote</div>';
    document.body.appendChild(quoteLoaderEl);
    return quoteLoaderEl;
  }

  function setQuoteLoaderLogo(loader) {
    if (!loader) return;
    var image = loader.querySelector('.callahan-loader__mark img');
    if (!image || image.getAttribute('src')) return;
    var source = document.querySelector('.header__heading-logo, header img[src], img[src*="logo"]');
    var src = source ? (source.currentSrc || source.getAttribute('src') || '') : '';
    if (src) image.src = src;
  }

  function showQuoteLoader() {
    var loader = getQuoteLoader();
    if (!loader) return;
    setQuoteLoaderLogo(loader);
    loader.hidden = false;
  }

  function hideQuoteLoader() {
    if (quoteLoaderEl) quoteLoaderEl.hidden = true;
  }

  function saveState() {
    if (!state) return;
    try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (error) {}
  }

  function disconnectRealtime() {
    if (realtimeClient && realtimeChannel) {
      try { realtimeClient.removeChannel(realtimeChannel); } catch (error) {}
    }
    realtimeChannel = null;
    realtimeClient = null;
  }

  function clearState() {
    hideQuoteLoader();
    window.clearTimeout(terminalTimer);
    terminalTimer = 0;
    disconnectRealtime();
    state = null;
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
      window.sessionStorage.removeItem(TOKEN_KEY);
    } catch (error) {}
  }

  function loadState() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved || !isToken(saved.token)) return null;
      if (!Number.isFinite(Number(saved.startedAt)) || Date.now() - Number(saved.startedAt) > STATUS_TTL_MS) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        window.sessionStorage.removeItem(TOKEN_KEY);
        return null;
      }
      return saved;
    } catch (error) {
      return null;
    }
  }

  function stageView(kind, stage, mode) {
    var value = String(stage || 'pending').toLowerCase();
    if (kind === 'shopify') {
      if (value === 'success') return { tone:'success', icon:'✓', text:'Quote / Draft Order successfully created' };
      if (value === 'pending') return { tone:'pending', icon:'•', text:'Creating Quote / Draft Order…' };
      return { tone:'error', icon:'!', text:'Could not create the Quote / Draft Order in Shopify' };
    }
    if (kind === 'monday') {
      if (value === 'success') return { tone:'success', icon:'✓', text:'Lead successfully created in Monday.com' };
      if (value === 'pending') return { tone:'pending', icon:'•', text:'Confirming lead creation…' };
      if (value === 'blocked') return { tone:'error', icon:'!', text:'Lead was not created because Shopify failed' };
      return { tone:'error', icon:'!', text:'Monday.com lead creation was not confirmed' };
    }
    if (value === 'success' && mode === 'soft_quote_no_link') {
      return { tone:'success', icon:'✓', text:'Quote message sent; payment link intentionally omitted' };
    }
    if (value === 'success') return { tone:'success', icon:'✓', text:'Payment link successfully sent to customer' };
    if (value === 'pending') return { tone:'pending', icon:'•', text:'Confirming customer message delivery…' };
    if (value === 'blocked') return { tone:'error', icon:'!', text:'Payment message was not sent because Shopify failed' };
    return { tone:'error', icon:'!', text:'Payment link delivery was not confirmed' };
  }

  function cardActionsHtml(kind, stage) {
    if (!state) return '';
    var html = '';
    var adminUrl = safeUrl(state.adminUrl);
    var invoiceUrl = safeUrl(state.invoiceUrl);
    var mondayUrl = safeMondayUrl(state.mondayUrl);

    if (kind === 'shopify' && stage === 'success' && adminUrl) {
      html = '<a class="rep-tools__status-link rep-tools__status-link--primary" href="' + escapeHtml(adminUrl) + '" target="_blank" rel="noopener noreferrer">Open in Admin</a>';
    } else if (kind === 'monday' && stage === 'success' && mondayUrl) {
      var itemCount = Math.max(1, Number(state.mondayItemCount) || 1);
      var countLabel = itemCount > 1 ? ' (1 of ' + itemCount + ')' : '';
      html = '<a class="rep-tools__status-link rep-tools__status-link--primary" href="' + escapeHtml(mondayUrl) + '" target="_blank" rel="noopener noreferrer">Open in Monday' + countLabel + '</a>';
    } else if (kind === 'payment' && invoiceUrl) {
      html =
        '<a class="rep-tools__status-link rep-tools__status-link--secondary" href="' + escapeHtml(invoiceUrl) + '" target="_blank" rel="noopener noreferrer">Open Payment Link</a>' +
        '<button type="button" class="rep-tools__status-link rep-tools__status-copy" data-rep-copy-payment-link="' + escapeHtml(invoiceUrl) + '" aria-label="Copy payment link">Copy Payment Link</button>';
    }

    return html ? '<div class="cap-stage-card__actions">' + html + '</div>' : '';
  }

  function cardHtml(kind, title, stage, mode) {
    var view = stageView(kind, stage, mode);
    var extra = '';
    if (kind === 'shopify' && state && state.draftNumber && stage === 'success') {
      extra = '<div class="cap-stage-card__draft-label">Draft Order #</div>' +
        '<div class="cap-stage-card__draft-number">' + escapeHtml(state.draftNumber) + '</div>';
    }
    if (kind === 'monday' && view.tone === 'error' && stage !== 'blocked') {
      extra += '<div class="cap-stage-card__instruction">Do not continue. Contact Automations immediately.</div>';
    }
    if (kind === 'payment' && view.tone === 'error' && stage !== 'blocked') {
      extra += '<div class="cap-stage-card__instruction">Contact Automations. Use Copy Payment Link and send it manually.</div>';
    }
    return '<section class="cap-stage-card cap-stage-card--' + view.tone + '" data-cap-stage="' + kind + '">' +
      '<div class="cap-stage-card__source">' + escapeHtml(title) + '</div>' +
      '<div class="cap-stage-card__state"><span class="cap-stage-card__icon" aria-hidden="true">' + view.icon + '</span>' +
      '<span>' + escapeHtml(view.text) + '</span></div>' + extra + cardActionsHtml(kind, stage) + '</section>';
  }

  function render(alertText) {
    if (!statusEl || !state || !state.draftId) return;
    var snapshot = state.snapshot || {};
    var shopify = snapshot.shopify ? snapshot.shopify.state : 'success';
    var monday = snapshot.monday ? snapshot.monday.state : 'pending';
    var payment = snapshot.payment ? snapshot.payment.state : 'pending';
    var mode = snapshot.payment ? snapshot.payment.mode : '';
    var alert = alertText ? '<div class="cap-stage-alert">' + escapeHtml(alertText) + '</div>' : '';

    rendering = true;
    statusEl.classList.add('cap-quote-stage-status-shell');
    statusEl.innerHTML = alert +
      '<div class="cap-quote-stage-grid" role="status" aria-live="polite">' +
      cardHtml('shopify', 'Shopify', shopify, mode) +
      cardHtml('monday', 'Monday.com', monday, mode) +
      cardHtml('payment', 'Podium', payment, mode) +
      '</div>';
    window.setTimeout(function () { rendering = false; }, 0);
  }

  function allTerminal() {
    if (!state || !state.snapshot) return false;
    return ['monday','payment'].every(function (key) {
      return String(state.snapshot[key] && state.snapshot[key].state || 'pending') !== 'pending';
    });
  }

  function armTerminalTimeout() {
    window.clearTimeout(terminalTimer);
    if (!state || allTerminal()) return;
    var elapsed = Date.now() - Number(state.startedAt || Date.now());
    terminalTimer = window.setTimeout(function () {
      if (!state || !state.snapshot) return;
      if (state.snapshot.monday.state === 'pending') state.snapshot.monday.state = 'unconfirmed';
      if (state.snapshot.payment.state === 'pending') state.snapshot.payment.state = 'unconfirmed';
      saveState();
      hideQuoteLoader();
      render('Real-time confirmation timed out. Contact Automations before continuing.');
      disconnectRealtime();
    }, Math.max(1000, TERMINAL_TIMEOUT_MS - elapsed));
  }

  function applyBroadcast(message) {
    if (!state || !isToken(state.token)) return;
    var payload = message && message.payload ? message.payload : message || {};
    if (String(payload.status_token || '').toLowerCase() !== state.token) return;
    var stage = String(payload.stage || '').toLowerCase();
    if (!['shopify','monday','payment'].includes(stage)) return;
    var nextState = String(payload.state || '').toLowerCase();
    if (!['pending','success','failed','blocked','unconfirmed'].includes(nextState)) return;
    state.snapshot = state.snapshot || {};
    state.snapshot[stage] = state.snapshot[stage] || {};
    state.snapshot[stage].state = nextState;
    if (stage === 'monday') {
      var mondayUrl = safeMondayUrl(payload.monday_url || payload.mondayUrl);
      var mondayItemCount = Number(payload.monday_item_count || payload.mondayItemCount || 0);
      if (mondayUrl) state.mondayUrl = mondayUrl;
      if (Number.isInteger(mondayItemCount) && mondayItemCount > 0) state.mondayItemCount = mondayItemCount;
    }
    if (stage === 'payment' && payload.mode) state.snapshot.payment.mode = String(payload.mode);
    saveState();
    if (stage === 'monday' && nextState !== 'pending') hideQuoteLoader();
    render();
    if (allTerminal()) {
      window.clearTimeout(terminalTimer);
      terminalTimer = 0;
      disconnectRealtime();
    }
  }

  function connectRealtime(token) {
    token = String(token || '').trim().toLowerCase();
    if (!isToken(token)) return;
    disconnectRealtime();
    var config = window.__CAP_SR1_CONFIG__ || {};
    if (!window.supabase || typeof window.supabase.createClient !== 'function' ||
        !config.quoteStatusSupabaseUrl || !config.quoteStatusPublishableKey) {
      if (state && state.draftId) render('Real-time status connection is unavailable. Contact Automations.');
      return;
    }
    realtimeClient = window.supabase.createClient(
      config.quoteStatusSupabaseUrl,
      config.quoteStatusPublishableKey,
      { auth: { persistSession:false, autoRefreshToken:false, detectSessionInUrl:false } }
    );
    realtimeChannel = realtimeClient
      .channel('quote-status:' + token, { config: { broadcast: { self:false } } })
      .on('broadcast', { event:'status' }, applyBroadcast)
      .subscribe(function (channelStatus) {
        if (channelStatus === 'CHANNEL_ERROR' && state && state.draftId) {
          render('Real-time status connection failed. Contact Automations if the pending stages do not update.');
        }
      });
    armTerminalTimeout();
  }

  function beginStatusToken(token) {
    token = String(token || '').trim().toLowerCase();
    if (!isToken(token)) return;
    showQuoteLoader();
    state = {
      token: token,
      draftId: '',
      draftNumber: '',
      adminUrl: '',
      invoiceUrl: '',
      mondayUrl: '',
      mondayItemCount: 0,
      startedAt: Date.now(),
      snapshot: { shopify:{state:'pending'}, monday:{state:'pending'}, payment:{state:'pending',mode:''} }
    };
    try { window.sessionStorage.setItem(TOKEN_KEY, token); } catch (error) {}
    saveState();
    connectRealtime(token);
  }

  function draftIdFromAdminUrl(url) {
    var match = String(url || '').match(/\/draft_orders\/(\d+)/i);
    return match ? 'gid://shopify/DraftOrder/' + match[1] : '';
  }

  function captureSuccess() {
    var numberEl = statusEl.querySelector('.rep-tools__draft-number');
    var adminLink = statusEl.querySelector('a[href*="/draft_orders/"]');
    var paymentLink = statusEl.querySelector('a.rep-tools__status-link--secondary');
    var adminUrl = adminLink ? safeUrl(adminLink.href) : '';
    var draftId = draftIdFromAdminUrl(adminUrl);
    if (!draftId) return;

    var token = state && isToken(state.token) ? state.token : '';
    if (!token) {
      try { token = String(window.sessionStorage.getItem(TOKEN_KEY) || '').trim().toLowerCase(); } catch (error) {}
    }
    var priorSnapshot = state && state.snapshot ? state.snapshot : null;
    state = {
      token: token,
      draftId: draftId,
      draftNumber: String(numberEl ? numberEl.textContent : '').trim(),
      adminUrl: adminUrl,
      invoiceUrl: paymentLink ? safeUrl(paymentLink.href) : '',
      mondayUrl: state && safeMondayUrl(state.mondayUrl) || '',
      mondayItemCount: state && Number(state.mondayItemCount) || 0,
      startedAt: state && state.startedAt ? state.startedAt : Date.now(),
      snapshot: priorSnapshot || { shopify:{state:'success'}, monday:{state:'pending'}, payment:{state:'pending',mode:''} }
    };
    state.snapshot.shopify = {state:'success'};
    saveState();
    render();
    if (isToken(token) && !realtimeChannel && !allTerminal()) connectRealtime(token);
    else armTerminalTimeout();
  }

  function captureFailure() {
    hideQuoteLoader();
    var detail = String(statusEl.textContent || '').trim();
    disconnectRealtime();
    state = {
      token: state && state.token || '',
      draftId: 'failed',
      draftNumber: '',
      adminUrl: '',
      invoiceUrl: '',
      startedAt: Date.now(),
      snapshot: { shopify:{state:'failed'}, monday:{state:'blocked'}, payment:{state:'blocked',mode:''} }
    };
    rendering = true;
    statusEl.classList.add('cap-quote-stage-status-shell');
    statusEl.innerHTML = '<div class="cap-stage-alert">' + escapeHtml(detail || 'Shopify did not confirm the Draft Order.') + '</div>' +
      '<div class="cap-quote-stage-grid" role="status" aria-live="polite">' +
      cardHtml('shopify', 'Shopify', 'failed', '') +
      cardHtml('monday', 'Monday.com — Lead & Quote Sender', 'blocked', '') +
      cardHtml('payment', 'Podium — Customer Payment Message', 'blocked', '') +
      '</div>';
    window.setTimeout(function () { rendering = false; }, 0);
  }

  function inspectStatus() {
    if (rendering || !statusEl || statusEl.querySelector('.cap-quote-stage-grid')) return;
    if (lastAction !== 'create') return;
    if (statusEl.classList.contains('rep-tools__status--success')) captureSuccess();
    else if (statusEl.classList.contains('rep-tools__status--error')) captureFailure();
  }

  function bind() {
    statusEl = document.getElementById('rep-tools-status');
    if (!statusEl) return;

    window.addEventListener('cap:quote-status-token', function (event) {
      beginStatusToken(event && event.detail ? event.detail.token : '');
    });

    document.addEventListener('click', function (event) {
      var create = event.target.closest('#rep-create-draft');
      var update = event.target.closest('#rep-update-draft');
      var clear = event.target.closest('#rep-clear-fields, #rep-clear-cart, #rep-clear-cart-fields');
      if (create) {
        clearState();
        lastAction = 'create';
      } else if (update) {
        lastAction = 'update';
      } else if (clear) {
        clearState();
        lastAction = '';
      }
    }, true);

    observer = new MutationObserver(inspectStatus);
    observer.observe(statusEl, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});

    var saved = loadState();
    if (saved) {
      state = saved;
      lastAction = 'create';
      if (state.draftId && state.draftId !== 'failed') render();
      if (state.snapshot && state.snapshot.monday && state.snapshot.monday.state === 'pending') showQuoteLoader();
      if (!allTerminal()) connectRealtime(state.token);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
})();